import { FormControl, FormHelperText, Input } from '@mui/joy';
import { Controller } from 'react-hook-form';

import { FormError, FormLabel } from 'core/elements';
import { toFieldFocusRef } from 'core/utils/fieldFocus';

import { IInputProps } from './Input';

const InputWithControllerView = ({
  control,
  error,
  name,
  type,
  label,
  tooltip,
  required = false,
  defaultValue,
  onChange,
  placeholder = '',
  slotProps,
  disabled = false,
  size,
  showFieldError = false,
  helperTexts = [],
  helperTextSxProps = {},
  ...rest
}: IInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { ref, ...field } }) => {
        return (
          <FormControl error={Boolean(error)} size={size}>
            {label && (
              <FormLabel required={required} tooltip={tooltip}>
                {label}
              </FormLabel>
            )}

            <Input
              type={type}
              {...field}
              {...rest}
              value={field?.value || ''}
              onChange={(e) => {
                field.onChange(e);
                onChange && onChange(e);
              }}
              placeholder={placeholder}
              slotProps={{
                ...slotProps,
                input: { ...slotProps?.input, ref: toFieldFocusRef(ref) },
              }}
              disabled={disabled}
              size={size}
            />

            {showFieldError && error && <FormError error={error} />}

            {helperTexts?.map((helperText: string | JSX.Element, index: number) => (
              <FormHelperText key={index} sx={{ fontWeight: 500, ...helperTextSxProps }}>
                {helperText}
              </FormHelperText>
            ))}
          </FormControl>
        );
      }}
    />
  );
};

export default InputWithControllerView;
